import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ApiGenericResponse } from "../ApiGenericResponse";

const ENDPOINT = "/caosconfiguration/usersync/delete";

export class DeleteCaosUserSyncConfigurationCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: DeleteCaosUserSyncConfigurationReqData;

    constructor(installationsNames: Array<string>) {
        super();
        this.payload = new DeleteCaosUserSyncConfigurationReqData(installationsNames);
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(this.payload);
        return new ApiGenericResponse(res);
    }
}

export class DeleteCaosUserSyncConfigurationReqData {
    installationsNames: Array<string>;

    constructor(installationsNames: Array<string>) {
        this.installationsNames = installationsNames;
    }
}
